import { StockistShopifySdk } from '..'
import { StockistFieldsFragment } from '../generated'

export type Stockist = {
  title: string
  region: string
  subregion: string
  city: string
  url: string
  jewelry: boolean
  nailpolish: boolean
  lamp: boolean
}

export async function fetchStockists(): Promise<Stockist[]> {
  const stockists: Stockist[] = []

  let after: string | undefined = undefined
  let hasNextPage = true

  while (hasNextPage) {
const response = await StockistShopifySdk.stockists({
      first: 250,
      after,
    })

    const connection = response.metaobjects

    connection.edges.forEach(({ node }: { node: StockistFieldsFragment }) => {
      stockists.push({
        title: node.name?.value || '',
        region: node.region?.value || '',
        subregion: node.subregion?.value || '',
        city: node.city?.value || '',
        url: node.url?.value || '',
        jewelry: node.jewelry?.value === 'true',
        nailpolish: node.nailpolish?.value === 'true',
        lamp: node.lamp?.value === 'true',
      })
    })

    hasNextPage = connection.pageInfo.hasNextPage
    after = connection.pageInfo.endCursor || undefined
  }

  return stockists
}